import { render, staticRenderFns } from "./BaseModal.vue?vue&type=template&id=612defd6&scoped=true&"
import script from "./BaseModal.vue?vue&type=script&lang=js&"
export * from "./BaseModal.vue?vue&type=script&lang=js&"
import style0 from "./BaseModal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./BaseModal.vue?vue&type=style&index=1&id=612defd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612defd6",
  null
  
)

export default component.exports